import { LANGUAGE_SELECTOR_MAP } from 'app/components/molecules/LanguageSwitcher/constants';
import { LANGUAGE_ID_MAP } from 'app/features/erpSystem/constants';
import { Languages } from 'app/features/availableLanguages/slice/types';
import { LanguageType } from '../types';

// The new webshop (eriks.com) has no availableLanguages API,
// so the supported languages per country are maintained here.
export const newShopLanguages: { [key: string]: LanguageType[] } = {
  BE: ['en', 'fr', 'nl'],
  CH: ['de', 'fr'],
  DE: ['de'],
  FR: ['fr'],
  LU: ['de', 'fr'],
  NL: ['nl', 'en'],
};

export const isNewShop = (shopUrl?: string): boolean => {
  if (!shopUrl) return true;
  return shopUrl.includes('eriks.com');
};

export const getNewShopLanguages = (countryCode: string): Languages[] =>
  (newShopLanguages[countryCode] || [])
    .map(lang => LANGUAGE_SELECTOR_MAP[LANGUAGE_ID_MAP[lang]])
    .filter(Boolean)
    .map(languageOption => ({ ...languageOption }));
